import React, { useState } from 'react';
import { SimpleSpinny } from '../../Nav/Spinny';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import TicketGrid from '../GridControls/TicketGrid';
import { TicketApi } from '../../../redux/api/TicketApi';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Card, CardBody, CardHeader } from '@progress/kendo-react-layout';
import { Console } from 'console';

interface HierarchyFormProps {
    isParent: boolean;
    ticketId: number;
    companyId?: number;
    parentCallId?: number;
    onParentChange: (event: { value: boolean }) => void;
    onChildChange: (event: { value: number }) => void;
    onTicketSelected: (Id?: number) => void;
    onRemoveHierarchy?: () => void;
}

const HierarchyForm: React.FC<HierarchyFormProps> = ({ onRemoveHierarchy, onTicketSelected, onParentChange, onChildChange, parentCallId, isParent, ticketId, companyId }) => {
    //user profile
    const { data: profile } = TicketApi.useGetUserProfileQuery();
    const isChild = (parentCallId > 0 || parentCallId === 0)
    const { data: parentTickets, isLoading } = TicketApi.useGetOpenParentTicketsQuery(undefined, { skip: !isChild });
    const { data: childTickets, isLoading: loadingChildren } = TicketApi.useGetChildTicketsQuery(ticketId, { skip: !isParent });
    const { data: parentChildren, isLoading: loadingParentChildren } = TicketApi.useGetChildTicketsQuery(parentCallId, { skip: isParent || parentCallId === null || parentCallId === 0 });
    const childTicketLabel = parentCallId > 0 ? `Child to ${parentCallId}` : "Child to ..."

    //console.log('childTicketLabel', childTicketLabel, parentCallId, typeof parentCallId)
    const onChildClick = (event) => {
        //Warning when going from Parenmt to None
        if (isParent) {
            if (!childTickets?.length || window.confirm(`Are you sure you want to remove the parent hierarchy from ${profile?.Phrases.CallPhrase} #${ticketId}? \n\n This will remove the hierarchy from the follow child ${profile?.Phrases.CallPhrase}s: \n ${childTickets.map(t => t.ID).join(', ')}`))
                onChildChange({ value: 0 })
            else
                return;
        }
        onChildChange({ value: 0 })
    }
    const onNoneClick = () => {
        //Warning when going from Parenmt to None
        if (isParent) {
            if (!childTickets?.length || window.confirm(`Are you sure you want to remove the parent hierarchy from ${profile?.Phrases.CallPhrase} #${ticketId}? \n\n This will remove the hierarchy from the follow child ${profile?.Phrases.CallPhrase}s: \n ${childTickets.map(t => t.ID).join(', ')}`))
                onRemoveHierarchy();
            else
                return;
        } else if (isChild && parentCallId > 0) {
            if (window.confirm(`Are you sure you want to remove the child hierarchy from ${profile?.Phrases.CallPhrase} #${ticketId}?`))
                onRemoveHierarchy();
            else
                return;
        } else {
            onRemoveHierarchy();
        }
    }

    return (
        <div className='ticket-hierarchy'>
            <div>
                {/* parentCallId={parentCallId === undefined ? 'yes' : 'no'} */}
                <ButtonGroup className='hierarchy-toggle-view'>
                    <Button className={isParent && 'selected'} size='large'
                        imageUrl='./images/parent.png'
                        selected={isParent}
                        onClick={() => onParentChange({ value: true })}
                    > Parent</Button>
                    <Button className={isChild && 'selected'} size='large'
                        imageUrl='./images/child.png'
                        selected={isChild}
                        onClick={onChildClick}
                    >{childTicketLabel}</Button>
                    <Button className={!isParent && !isChild && 'selected'} size='large'
                        // svgIcon={svg.clearCssIcon}
                        selected={!isParent && !isChild}
                        onClick={() => onNoneClick()}
                    >None</Button>
                </ButtonGroup>
                {/* parentCallId:{isNaN(parentCallId) ? 'no' : 'yes'} */}
            </div>
            {(isChild || isParent) &&
                <fieldset className={"k-form-fieldset"}>
                    <div className="m-3 hierarchy-grid">
                        {isLoading || loadingChildren || loadingParentChildren ? <SimpleSpinny /> :
                            <>
                                <div className='ms-3'>
                                    {/* {isChild && parentCallId ? <h6>Parent: {parentCallId}</h6> : <h6>Select Parent</h6>} */}
                                    {isParent && <h6>Child {profile?.Phrases.CallPhrase}s: {childTickets?.length || 0}</h6>}
                                </div>
                                <Card>
                                    <CardBody>
                                        {isChild ? <TicketGrid selectable={true} data={parentTickets} onTicketSelected={onTicketSelected} selectedTicketId={parentCallId} subGridData={parentChildren} subGridHeader={`Child ${profile?.Phrases.CallPhrase}s: ${parentChildren?.length}`} />
                                            : <TicketGrid selectable={false} data={childTickets || []} companyId={companyId} />
                                        }</CardBody></Card>
                            </>
                        }
                    </div>
                </fieldset>
            }
        </div>
    );
};

export default HierarchyForm;